/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@font-face{font-family:Publico-Light;src:url(/assets/fonts/Publico-Light.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Publico-Headline-Light;src:url(/assets/fonts/PublicoHeadline-Light-Web.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Publico-Headline-Roman;src:url(/assets/fonts/PublicoHeadline-Roman-Web.woff) format(\"woff\");font-weight:300;font-style:normal}h1[_ngcontent-%COMP%]{color:#6e27c5}"];
export { styles as styles };
